import styled from 'styled-components';

export const PopupActionButton = styled.button`
  background-color: #eff2f5;
  border: none;
  border-radius: 8px;
  padding: 8px 24px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #000;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  text-align: center;

  &:hover {
    background-color: #e0e4e8;
    color: #000;
  }

  &:focus {
    outline: none;
  }
`;

export const PopupDangerActionButton = styled(PopupActionButton)`
  color: #ff3b30;

  &:hover {
    background-color: #ff3b30;
    color: #fff;
  }
`;
